import * as React from "react";
import { Grid, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
// 2026-10-22: the redesigned, role-based Dashboard (the old Dashboard.js stays in the repo, unused, until the owner is happy)
import dashboard from "../../Dashboard/v2/DashboardPage";
import Navbar from "../../Navbar/Navbar";
import Branch from "../../Master/Branch/Branch";
import BookingCode from "../../Master/CreateBookingCode/BookingCode";
// import Company from "../../Master/CreateCompany/Company";
import Company from "../../Master/CreateCompany/Companycopy";
import LinkBookingCode from "../../Master/LinkBookingCode/LinkBookingCode";
import PolicyPeriod from "../../Master/PolicyPeriod/PolicyPeriod";
import PolicyType from "../../Master/PolicyType/PolicyType";
import Product from "../../Master/Product/Product";
import MasterCompany from "../../Master/MasterCompany/MasterCompany";
import ManageUser from "../../User/ManageUser";
import RenewalPolicy from "../../RenewalPolicy/RenewalPolicy";
import CompanyLogin from "../../CompanyLogin/CompanyLogin";
import CommisionReceivable from "../../Utilites/CommisionReceivable/CommisionReceivable";
import ReceivableStatus from "../../Utilites/ReceivableStatus/ReceivableStatus";
import UserPayable from "../../Utilites/UserPayable/UserPayable";
import BranchPayable from "../../Utilites/BranchPayable/BranchPayable";
import OfficeExpenses from "../../Utilites/OfficeExpenses/OfficeExpenses";
import MasterReport from "../../Report/MasterReport/MasterReport";
import ChequeStatus from "../../Utilites/ChequeStatus/ChequeStatus";
import LogStatus from "../../Utilites/LogStatus/LogStatus";
import PolicyChequeReport from "../../Report/PolicyChequeStatus/PolicyChequeStatus";
import ReceivableBulkUpload from "../../Utilites/ReceivableBulkUpload/ReceivableBulkUpload";
import RayalchatUsersInfo from "../../../Pages/RayalchatUsersInfo/RayalchatUsersInfo";
import PaymentPaidAndReceived from "../../Report/PaymentPaidandReceived/PaymentPaidandReceived";
import Policycreate from "../../Policy/CreatePolicy/CretePolicy";
import SearchPolicy from "../../Policy/SearchPolicy/SearchPolicy";
import ReceivableStatusNew from "../../Utilites/ReceivableStatusNew/ReceivableStatusNew";
import PolicyList from "../../Policy/PolicyList/PolicyList";
import CCEntry from "../../Policy/CCEntry/CCEntry";
import PolicyMapping from "../../Policy/PolicyMapping/PolicyMapping";
import MotorCalculation from "../../MotorCalculation/MotorCalculation";
import UserConfig from "../../Configuration/UserConfig/UserConfig";
import AllPolicy from "../../Master/OldPolicyList/AllPolicy/AllPolicy";
import ApprovedPolicy from "../../Master/OldPolicyList/ApprovedPolicy/ApprovedPolicy";
import PendingPolicy from "../../Master/OldPolicyList/PendingPolicy/PendingPolicy";
import EntryPending from "../../Master/OldPolicyList/EntryPending/EntryPending";
import RejectedPolicy from "../../Master/OldPolicyList/RejectedPolicy/RejectedPolicy";
import ChequePending from "../../Master/OldPolicyList/ChequePending/ChequePending";
import Client from "../../Client/Client";
import ServerControl from "../../ServerControl/ServerControl";
import ClientSignUp from "../../Client/ClientSignUp";
import SubProduct from "../../Master/SubProduct/SubProduct";
import SubBookingCode from "../../Master/SubBookingCode/SubBookingCode";
import FuelType from "../../Master/FuelType/FuelType";
import Payout from "../../Master/Payout/Payout";
import UserWallet from "../../UserWallet/Wallet";
import MotorWallet from "../../UserWallet/MotorWallet";
import BranchWallet from "../../BranchWallet/BranchWallet";
import CompanyWallet from "../../CompanyWallet/CompanyWallet";
import ReceivableConfig from "../../Configuration/ReceivableConfig/ReceivableConfig";
import BranchConfig from "../../Configuration/BranchConfig/BranchConfig";
import RTOMapping from "../../Configuration/RTOMapping/RTOMapping";
import TdsReport from "../../Report/TdsReport/TdsReport";
import BookingReport from "../../Report/BookingReport/BookingReport";
import VehicleMake from "../../Master/VehicleMake/VehicleMake";
import MotorReport from "../../Report/MotorReport/MotorReport";
import MakeModel from "../../Master/MakeModel/MakeModel";
import MakeModelCombo from "../../Master/MakeModelCombo/MakeModelCombo";
import MasterChangeLog from "../../Master/MasterChangeLog/MasterChangeLog";
import LinkSupplier from "../../Master/LinkSupplier/LinkSupplier";
import CommonConfig from "../../Configuration/CommonConfig/CommonConfig";
import BreadcrumbsComponent from "../../Breadcrumb/Breadcrumb";
import AddOn from "../../Master/AddOn/AddOn";
import OnlinePolicy from "../../Policy/OnlinePolicy/OnlinePolicy";
import ViewOnlinePolicyHistory from "../../Policy/OnlinePolicy/ViewOnlinePolicyHistory";
import ViewOnlinePolicy from "../../Policy/OnlinePolicy/ViewOnlinePolicy";
import Financier from "../../Master/Financier/Financier";
import BulkUploadedPolicyList from "../../Policy/BulkUploadedPolicyList/BulkUploadedPolicyList";
import BriskWallet from "../../UserWallet/BriskWallet";
import BriskTransactionHistory from "../../UserWallet/BriskTransactionHistory";
import RTOCityLocation from "../../Master/RTOCityLocation/RTOCityLocation";
import NilDip from "../../Master/NilDip/NilDip";
import ClientCompanyWallet from "../../ClientCompanyWallet/ClientCompanyWallet";
import AdminPolicyWallet from "../../AdminPolicyWallet/AdminPolicyWallet";
import UserPolicyWallet from "../../UserPolicyWallet/UserPolicyWallet";
import AddMoneyToUser from "../../AddMoneyToUser/AddMoneyToUser";

// New BRISK CPA / RSA Components
import NewBriskCreateCertificate from "../../BRISK_CPA_RSA/BriskCreateCertificate";
import NewBriskDownloadCertificate from "../../BRISK_CPA_RSA/BriskDownloadCertificate";
import NewBriskTransactionHistory from "../../BRISK_CPA_RSA/BriskTransactionHistory";
import NewBriskWallet from "../../BRISK_CPA_RSA/BriskWallet";
// Brisk certificates (new, "V2"): REACT_APP_BRISK_V2_ENABLED picks the page behind /briskCreateCertificate (off = the
// page above, unchanged) and adds the Brisk Certificate List.
import { pickBriskCreatePage, briskV2ListPages } from "../../Policy/BriskCreateCertificateV2/briskV2Pages";
import RoadzenUsers from "../../Roadzen/RoadzenUsers/RoadzenUsers";
import RoadzenWallet from "../../Roadzen/RoadzenWallet/RoadzenWallet";
import RoadzenCompanyWallet from "../../Roadzen/RoadzenCompanyWallet/RoadzenCompanyWallet";
import RoadzenCreateCertificate from "../../Roadzen/RoadzenCertificate/RoadzenCreateCertificate";
import RoadzenCertificateList from "../../Roadzen/RoadzenCertificate/RoadzenCertificateList";
import { ROADZEN_CERT_LIST_PATH, ROADZEN_COMPANY_WALLET_PATH, ROADZEN_CREATE_CERT_PATH, ROADZEN_USERS_PATH, ROADZEN_WALLET_PATH } from "../../Roadzen/roadzenPaths";

const elements = {
  "/dashboard": dashboard,
  "/branch": Branch,
  "/bookingcode": BookingCode,
  "/company": Company,
  "/linkbookingcode": LinkBookingCode,
  "/linksupplier": LinkSupplier,
  "/policyperiod": PolicyPeriod,
  "/policytype": PolicyType,
  "/product": Product,
  "/masterCompany": MasterCompany,
  "/user": ManageUser,
  "/renewalPolicy": RenewalPolicy,
  "/companyLogin": CompanyLogin,
  "/commisionReceivale": CommisionReceivable,
  "/receivaleStatus": ReceivableStatus,
  "/userPayable": UserPayable,
  "/branchPayable": BranchPayable,
  "/officeExpenses": OfficeExpenses,
  "/masterReport": MasterReport,
  "/chequeStatus": ChequeStatus,
  "/logStatus": LogStatus,
  "/policyChequeReport": PolicyChequeReport,
  "/receivableBulkUpload": ReceivableBulkUpload,
  "/rayalchat-users-info": RayalchatUsersInfo,
  "/paymentPaidAndReceived": PaymentPaidAndReceived,
  "/policycreate": Policycreate,
  "/searchPolicy": SearchPolicy,
  "/receivableStatusNew": ReceivableStatusNew,
  "/policyList": PolicyList,
  "/bulkUploadedPolicyList": BulkUploadedPolicyList,
  "/ccentry": CCEntry,
  "/policyMapping": PolicyMapping,
  "/motorCalculation": MotorCalculation,
  "/userConfiguration": UserConfig,
  "/receivableConfiguration": ReceivableConfig,
  "/branchConfiguration": BranchConfig,
  "/commonConfiguration": CommonConfig,
  "/allPolicy": AllPolicy,
  "/approvedPolicy": ApprovedPolicy,
  "/pendingPolicy": PendingPolicy,
  "/entryPending": EntryPending,
  "/rejectedPolicy": RejectedPolicy,
  "/chequePending": ChequePending,
  "/client": Client,
  "/serverControl": ServerControl,
  "/clientSignUp": ClientSignUp,
  "/subProduct": SubProduct,
  "/subBookingCode": SubBookingCode,
  "/fuelType": FuelType,
  "/payout": Payout,
  "/userWallet": UserWallet,
  "/motorWallet": MotorWallet,
  "/branchWallet": BranchWallet,
  "/companyWallet": CompanyWallet,
  "/clientCompanyWallet": ClientCompanyWallet,
  "/adminPolicyWallet": AdminPolicyWallet,
  "/userPolicyWallet": UserPolicyWallet,
  "/addPolicyWalletMoney": AddMoneyToUser,
  "/rtoMapping": RTOMapping,
  "/tdsReport": TdsReport,
  "/bookingReport": BookingReport,
  "/vehicleMake": VehicleMake,
  "/makeModel": MakeModel,
  "/makeModelCombo": MakeModelCombo,
  "/masterChangeLog": MasterChangeLog,
  "/financier": Financier,
  "/MotorReport": MotorReport,
  "/addon": AddOn,
  "/onlinePolicy": OnlinePolicy,
  "/briskCreateCertificate": pickBriskCreatePage(),
  ...briskV2ListPages(),
  [ROADZEN_USERS_PATH]: RoadzenUsers,
  [ROADZEN_WALLET_PATH]: RoadzenWallet,
  [ROADZEN_COMPANY_WALLET_PATH]: RoadzenCompanyWallet,
  [ROADZEN_CREATE_CERT_PATH]: RoadzenCreateCertificate,
  [ROADZEN_CERT_LIST_PATH]: RoadzenCertificateList,
  "/briskWallet": BriskWallet,
  "/briskTransactionHistory": BriskTransactionHistory,
  "/rtoCityLocation": RTOCityLocation,
  "/nilDip": NilDip,
  "/briskCreateCertificates": NewBriskCreateCertificate,
  "/briskDownloadCertificate": NewBriskDownloadCertificate,
  "/briskTransactionHistorys": NewBriskTransactionHistory,
  "/briskWallets": NewBriskWallet,
};

// /onlinePolicy/view/history/:policyId (2026-10-22) - its own page; the URL keeps the id, so a refresh stays on it
export const isHistoryPage = (path) => /^\/onlinePolicy\/view\/history\/[^/]+$/.test(String(path || ""));

export default function Dashboard() {
  const [currentEl, setCurrentEl] = React.useState();
  const location = useLocation();

  React.useEffect(() => {
    if (location.pathname) {
      // Handle exact matches first
      if (Object.keys(elements).includes(location.pathname)) {
        setCurrentEl(location.pathname);
      } else {
        // Handle dynamic routes like /onlinePolicy/edit/:policyId
        const pathSegments = location.pathname.split('/');
        if (isHistoryPage(location.pathname)) {
          // the policy's History is a page of its own (not inside the Online Policy screen, which would also load the list)
          setCurrentEl(location.pathname);
        } else if (pathSegments.length >= 3 && (pathSegments[1] === 'onlinePolicy' && pathSegments[2] === 'edit' || pathSegments[1] === 'onlinePolicy' && pathSegments[2] === 'view')) {
          setCurrentEl('/onlinePolicy');
        } else {
          // Try to find a matching base path
          const basePath = '/' + pathSegments[1];
          if (Object.keys(elements).includes(basePath)) {
            setCurrentEl(basePath);
          }
        }
      }
    }
  }, [location]);

  React.useEffect(() => {
    if (currentEl)
      window.history.replaceState(null, currentEl.split("/")[1], currentEl);
  }, [currentEl]);

  const Element = (elements[currentEl] && elements[currentEl]) || (isHistoryPage(currentEl) ? ViewOnlinePolicyHistory : undefined);

  return (
    <>
      <Navbar
      // setcurrentmenu={setCurrentEl}
      >
        <BreadcrumbsComponent />
        <Grid container p={{ xs: 0, md: 0 }}>
          <Grid item xs={12}>
            {Element && <Element />}
          </Grid>
        </Grid>
      </Navbar>
    </>
  );
}
